import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { IGetDetailedNotificationResponse } from "../models/notification/responses/getDeatiledNotificationResponse";
import { DetailedNotificationModel } from "../models/notification/DetailedNotification";
let NotificationModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let NotificationModule = class NotificationModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "AppNotification";
            this.notificationCount = 0;
            this.totalCount = 0;
            this.requestTrackingPendingCount = 0;
            this.unreadNotificationCount = 0;
            this.notifications = [];
            this.notificationDetails = [];
        }
        async GetNotificationCount(tenantId) {
            var url = tenantId + `/${this.apiNode}`;
            let { data } = await service.get(url);
            this.SetNotificationCount(data);
            return data;
        }
        async UpdateIsActive(notificationId) {
            var url = `${getTenantId()}/${this.apiNode}/notification?notificationId=${notificationId}`;
            let { data } = await service.put(url);
            if (data) {
                this.RemoveNotification(notificationId);
                return data;
            }
        }
        async GetNotificationDetails(payload) {
            var url = `${getTenantId()}/${this.apiNode}/notification-details?skipCount=${payload.skipCount}&filterType=${payload.filterType}&isNew=${payload.isNew}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetNotificationDetails(plainToClass(DetailedNotificationModel, data.notifications));
                this.GetCount(data);
                this.ClearCount();
                return data;
            }
        }
        async GetNotifications(payload) {
            var url = `${getTenantId()}/${this.apiNode}/notification-details?skipCount=${payload.skipCount}&filterType=${payload.filterType}&isNew=${payload.isNew}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetNotifications(plainToClass(DetailedNotificationModel, data.notifications));
                this.ClearCount();
                return data;
            }
        }
        async UpdateIsSeen(notificationId) {
            var url = `${getTenantId()}/${this.apiNode}/` + notificationId;
            let { data } = await service.put(url);
            if (data) {
                this.SetIsSeen(notificationId);
                this.ReduceUnseenCount();
                return data;
            }
        }
        async rejectSubProjectLinkingNotification(notificationId) {
            var url = `${getTenantId()}/${this.apiNode}/reject-project-from-link?notificationId=${notificationId}`;
            let { data } = await service.delete(url);
            if (data) {
                this.ReduceCount();
                this.RemoveNotification(notificationId);
                return data;
            }
        }
        async UpdateAllNotificationRead() {
            var url = `${getTenantId()}/${this.apiNode}/mark-as-read`;
            let { data } = await service.put(url);
            if (data) {
                this.SetAllIsSeen();
                return data;
            }
        }
        SetNotificationCount(data) {
            this.notificationCount = data;
        }
        SetNotification(data) {
            this.notificationCount += data;
        }
        SetNotificationDetails(notifications) {
            this.notifications = this.notifications.concat(notifications);
        }
        SetNotifications(notifications) {
            this.notificationDetails = notifications;
        }
        ClearCount() {
            this.notificationCount = 0;
        }
        async GetCount(data) {
            this.totalCount = data.totalCount;
            this.requestTrackingPendingCount = data.requestTrackingPendingCount;
            this.unreadNotificationCount = data.unreadNotificationCount;
        }
        ClearNotification() {
            this.notifications = [];
        }
        SetIsSeen(notificationId) {
            for (var i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id == notificationId) {
                    this.notifications[i].isSeen = true;
                }
            }
        }
        SetIsActive(notificationId) {
            for (var i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id == notificationId) {
                    this.notifications[i].isComplete = false;
                    if (this.notifications[i].isSeen != true) {
                        this.notifications[i].isSeen = true;
                        this.unreadNotificationCount = this.unreadNotificationCount - 1;
                    }
                }
            }
            this.requestTrackingPendingCount = this.requestTrackingPendingCount - 1;
        }
        ReduceUnseenCount() {
            if (this.unreadNotificationCount != 0) {
                this.unreadNotificationCount = this.unreadNotificationCount - 1;
            }
        }
        ReduceCount() {
            if (this.unreadNotificationCount != 0) {
                this.unreadNotificationCount = this.unreadNotificationCount - 1;
            }
            this.requestTrackingPendingCount = this.requestTrackingPendingCount - 1;
            this.totalCount = this.totalCount - 1;
        }
        RemoveNotification(notificationId) {
            for (var i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id == notificationId) {
                    this.notifications.splice(i, 1);
                }
            }
            if (this.unreadNotificationCount != 0) {
                this.unreadNotificationCount = this.unreadNotificationCount - 1;
            }
        }
        SetAllIsSeen() {
            this.notifications = this.notifications.map((notification) => {
                return {
                    ...notification,
                    isSeen: true,
                };
            });
            this.unreadNotificationCount = 0;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], NotificationModule.prototype, "GetNotificationCount", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Guid !== "undefined" && Guid) === "function" ? _a : Object]),
        __metadata("design:returntype", Promise)
    ], NotificationModule.prototype, "UpdateIsActive", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], NotificationModule.prototype, "GetNotificationDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], NotificationModule.prototype, "GetNotifications", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], NotificationModule.prototype, "UpdateIsSeen", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", Promise)
    ], NotificationModule.prototype, "rejectSubProjectLinkingNotification", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], NotificationModule.prototype, "UpdateAllNotificationRead", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetNotificationCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetNotification", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetNotificationDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetNotifications", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "ClearCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof IGetDetailedNotificationResponse !== "undefined" && IGetDetailedNotificationResponse) === "function" ? _f : Object]),
        __metadata("design:returntype", Promise)
    ], NotificationModule.prototype, "GetCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "ClearNotification", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Guid !== "undefined" && Guid) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetIsSeen", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof Guid !== "undefined" && Guid) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetIsActive", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "ReduceUnseenCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "ReduceCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "RemoveNotification", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationModule.prototype, "SetAllIsSeen", null);
    NotificationModule = __decorate([
        Module({ dynamic: true, store: store, name: "notification", namespaced: true })
    ], NotificationModule);
    return NotificationModule;
})();
export const NotificationsModule = getModule(NotificationModule);
